import axios from 'axios';
import qs from 'qs';
import moment from 'moment';
import BrowserStore from 'store';
import { parseResponse, handleError } from '@/_helpers/utils.js';

export default {
  namespaced: true,

  state() {
    return {
      rates: null,
      tariffs: null,
      price_blocks: [
        {
          id: 'vacancies',
          value: null
        },
        {
          id: 'responses',
          value: 80
        },
        {
          id: 'sms',
          value: 500
        },
        {
          id: 'users',
          value: null
        }
      ]
    };
  },

  mutations: {
    SET_RATES_LIST: (state, rates) => {
      state.rates = rates;
    },

    SET_TARIFFS: (state, tariffs) => {
      state.tariffs = tariffs;
    },

    set_value(state, options) {
      let { id, value } = options;

      let block = state.price_blocks.find(el => el.id === id);
      let ind = state.price_blocks.findIndex(el => el.id === id);

      block.value = value;
      state.price_blocks.splice(ind, 1, block);
    }
  },

  actions: {
    async get_rates({ commit }) {
      await axios
        .get('/v3/company-limits', {
          params: { with: ['latestLog'], fields: ['userCount', 'vacancyCount'] },
          paramsSerializer: params => {
            return qs.stringify(params);
          }
        })
        .then(response => {
          // TODO: понять что за херню тут написали и где используется. Скорее всего удалить и использовать вместо этого геттеры как положено.
          const tmpRates = Object.assign(response.data, {
            users_count: response.data.userCount,
            vacancies_count: response.data.vacancyCount,
            last_purchase_responses_paid_count:
              response.data.latestLog !== null ? response.data.latestLog.response_paid_count : null,
            vacancy_balance:
              response.data.vacancy_limit !== null ? response.data.vacancy_limit - response.data.vacancyCount : null,
            last_purchase: response.data.latestLog !== null ? { date: response.data.latestLog.created_at } : null
          });
          delete tmpRates.userCount;
          delete tmpRates.vacancyCount;

          const rates = tmpRates;
          commit('SET_RATES_LIST', rates);

          if (BrowserStore.get('informer_seen') === undefined) {
            const seen = { days7: false, days3: false, days2: false, days1: false };
            BrowserStore.set('informer_seen', JSON.stringify(seen));
          }
        })
        .catch(err => handleError(err));
    },

    async update_rates({ commit }, params) {
      await axios
        .put('/1.0/company-limits', params)
        .then(response => {
          const rates = parseResponse(response).data[0];
          commit('SET_RATES_LIST', rates);
        })
        .catch(err => handleError(err));
    },

    async extend_rates(_, params) {
      await axios.post('/1.0/company-limits/renewal-tariff', params);
    },

    async fetchTariffs({ commit }) {
      await axios.get('/v3/tariffs').then(response => {
        commit('SET_TARIFFS', response.data._embedded.tariffs);
      });
    }
  },

  getters: {
    isFeatureDisabledByTariff: state => feature => {
      if (feature !== undefined && state.rates !== null) {
        const module = feature.replace('-', '_');

        if (state.rates[module] !== undefined && !state.rates[module]) {
          return true;
        }
      }

      return false;
    },

    getTariffById: state => tariffId => {
      if (state.tariffs !== null) {
        const tariff = state.tariffs.find(x => x.id === tariffId);

        if (tariff !== undefined) {
          return tariff;
        } else {
          return null;
        }
      }

      return null;
    },

    isRatesStarted: state => {
      if (state.rates !== null && state.rates.paid_from) {
        return moment(state.rates.paid_from).startOf('day').diff(moment().startOf('day'), 'days') <= 0;
      }

      return true;
    },

    isRatesExpired: state => {
      if (state.rates !== null && state.rates.paid_to !== undefined && state.rates.paid_to !== null) {
        return moment(state.rates.paid_to).startOf('day').diff(moment().startOf('day'), 'days') < 0;
      }

      return false;
    },

    ratesLeftDays: state => {
      if (state.rates !== null && state.rates.paid_to) {
        const leftDays = moment(state.rates.paid_to).startOf('day').diff(moment().startOf('day'), 'days');

        return leftDays < 0 ? 0 : leftDays;
      }

      return null;
    },

    response_balance: state => {
      if (state.rates === null || state.rates.response_balance === null || state.rates.response_limit === null) {
        return null; // not loaded or unlimited responses
      } else {
        return (
          state.rates.response_balance +
          (state.rates.monthly_response_balance || 0) +
          (state.rates.extra_response_balance || 0)
        );
      }
    },

    price_blocks: state => state.price_blocks
  }
};
